import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Table, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import './CustomerPage.css'; // Import the CSS file

const CustomerPage = () => {
  const [users, setUsers] = useState([]); // Fetch users from database
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [editingUser, setEditingUser] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await axios.get("https://agpipefitting.org.et/api/users");
        setUsers(response.data);
      } catch (error) {
        setErrorMessage('Error fetching users.');
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  const handleShowModal = (user = null) => {
    if (user) {
      setEditingUser(user);
      setNewUser(user); // Pre-fill the form with user data
    } else {
      setEditingUser(null);
      setNewUser({
        name: "",
        email: "",
        password: "",
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmitUser = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    if (editingUser) {
      try {
        const response = await axios.put(`https://agpipefitting.org.et/api/users/${editingUser.id}`, newUser);
        setUsers(users.map((user) => (user.id === response.data.id ? response.data : user)));
        setSuccessMessage('User updated successfully!');
        handleCloseModal();
      } catch (error) {
        setErrorMessage('Error updating user.');
      }
    } else {
      try {
        const response = await axios.post("https://agpipefitting.org.et/api/users", newUser);
        setUsers([...users, response.data]);
        setSuccessMessage('User added successfully!');
        handleCloseModal();
      } catch (error) {
        setErrorMessage('Error adding user.');
      }
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      await axios.delete(`https://agpipefitting.org.et/api/users/${id}`);
      setUsers(users.filter((user) => user.id !== id));
      setSuccessMessage('User deleted successfully!');
    } catch (error) {
      setErrorMessage('Error deleting user.');
    }
  };

  return (
    <div className="customer-page">
      <h2>User Management</h2>
      <Button variant="primary" onClick={() => handleShowModal()} className="mb-3">
        Add New User
      </Button>

      {loading ? (
        <Spinner animation="border" variant="primary" />
      ) : (
        <div className="user-list">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{new Date(user.created_at).toLocaleDateString()}</td>
                    <td>
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => handleShowModal(user)}
                        className="me-2"
                      >
                        Edit
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDeleteUser(user.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No users available.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}

      {/* Success/Error Alerts */}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}
      {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}

      {/* Modal for adding/editing user */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editingUser ? "Edit User" : "Add New User"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitUser}>
            <Form.Group controlId="userName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter user name"
                name="name"
                value={newUser.name}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group controlId="userEmail" className="mt-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter user email"
                name="email"
                value={newUser.email}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group controlId="userPassword" className="mt-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter user password"
                name="password"
                value={newUser.password}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                {editingUser ? "Update User" : "Add User"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CustomerPage;
